// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kWrV7"};
module.exports.__checksum = "d8a604d4fe2e"